import { render, staticRenderFns } from "./PreviewPortfolio.vue?vue&type=template&id=5d84cc4c&scoped=true&"
import script from "./PreviewPortfolio.vue?vue&type=script&lang=js&"
export * from "./PreviewPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPortfolio.vue?vue&type=style&index=0&id=5d84cc4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84cc4c",
  null
  
)

export default component.exports